import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components"
import { ReactNode } from "react"
import { TooltipContentProps, TooltipTriggerProps } from "@radix-ui/react-tooltip"

interface Props {
  elementTrigger: ReactNode
  content: string
  buttonAsAWrapper?: boolean
  triggerClassName?: string
  contentClassName?: string
  triggerProps?: TooltipTriggerProps
  contentProps?: TooltipContentProps
}

export const TooltipToElement = ({
  elementTrigger,
  content,
  buttonAsAWrapper = false,
  triggerClassName,
  contentClassName,
  triggerProps,
  contentProps
}: Props) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger className={`cursor-default ${triggerClassName}`} asChild={buttonAsAWrapper} {...triggerProps}>
        {elementTrigger}
      </TooltipTrigger>
      <TooltipContent className={contentClassName} {...contentProps}>
        {content}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
)
